// 相册类型
export const ALBUM_KIND = {
  OUTWARD: '4', // 外观
  HALL: '5', // 大厅
  EFFECT: '6', // 效果
  VR: '0',
  VIDEO: '10', //相册
  CELEBRITY: '11', // 网红打卡点
  MARRY_HOUSE: '12', //新娘房
  GUEST_HOUSE: '13', //客房
  SPECIAL_HOUSE: '14' //特色场地
}

// 审核状态
export const APPROVAL_STATUS = {
  WAIT: '2', // 审核中
  PASS: '1', // 审核通过
  FAIL: '3' // 审核不通过
}

export const VR_VERIFY_SUC = '1' // 审核通过
export const VR_VERIFY_ING = '2' // 审核中
export const VR_VERIFY_FAIL = '3' // 审核失败
export const VR_VERIFY_MAKING = '999' // 制作中

export const VR_BASIC_SETTING = 'INFO' // 基础设置
export const VR_VIEW_SETTING = 'VIEW' // 视角设置
export const VR_HOTSPOT_SETTING = 'HOTSPOT' // 热点设置

/**
 * 酒店路径
 */
export const PATH_HOTEL_MENU_MANAGE = '/localMerchant/menuManage'
export const PATH_HOTEL_MEAL_MANAGE = '/localMerchant/mealManage'
export const PATH_HOTEL_SITE_MANAGE = '/localMerchant/siteManage'

export const EDIT_WEDDING_HALL_PATH =
  '/localMerchant/siteManage/editWeddingHall'
export const EDIT_WEDDING_HALL_PATH_A = `#${EDIT_WEDDING_HALL_PATH}`

export const HOTEL_SITE_RANKING_PATH = '/localMerchant/siteManage/siteRanking'

export const HOTEL_MENU_RANKING_PATH = '/localMerchant/menuManage/menuRanking'
export const HOTEL_MENU_CREATE_PATH = '/localMerchant/menuManage/createMenu'
export const HOTEL_MENU_CREATE_PATH_A = `#${HOTEL_MENU_CREATE_PATH}`
export const HOTEL_MENU_EDIT_PATH = '/localMerchant/menuManage/editMenu'

export const VR_SELL_PATH = '/localMerchant/vr/sell'
export const VR_CREATE_PATH = '/localMerchant/vr/create'

// 酒店-套餐管理
export const MEAL_MANAGE_PATH = '/localMerchant/mealManage' // 套餐管理
export const MEAL_MANAGE_PATH_A = `#${MEAL_MANAGE_PATH}`

export const PUBLISH_MEAL_PATH = MEAL_MANAGE_PATH + '/create' // 发布套餐
export const PUBLISH_MEAL_PATH_A = `#${PUBLISH_MEAL_PATH}`

export const EDIT_MEAL_PATH = MEAL_MANAGE_PATH + '/edit/' // 编辑套餐
export const EDIT_MEAL_PATHH_A = `#${EDIT_MEAL_PATH}`

export const MEAL_REVIEW_PATH = MEAL_MANAGE_PATH + '/review' // 套餐管理-审核
export const MEAL_REVIEW_PATH_A = `#${MEAL_REVIEW_PATH}`

export const MEAL_DRAFT_BOX_PATH = MEAL_MANAGE_PATH + '/draftBox' // 套餐管理-草稿箱
export const MEAL_DRAFT_BOX_PATH_A = `#${MEAL_DRAFT_BOX_PATH}`
export const OSSM_PATH = '/localMerchant/ossm'

export const UNIQUE_INFO_PATH = '/localMerchant/uniqueInfo'
export const UNIQUE_INFO_PATH_A = `#${UNIQUE_INFO_PATH}`

// 服务说明
export const SERVICE_CONFIG_PATH = '/localMerchant/serviceConfig'
export const SERVICE_CONFIG_PATH_A = `#${SERVICE_CONFIG_PATH}`
// 升级服务
export const UPGRADE_SERVICE_PATH = '/localMerchant/upgradeService'
export const UPGRADE_SERVICE_PATH_A = `#${UPGRADE_SERVICE_PATH}`
export const UPGRADE_SERVICE_HOME_PATH = `${UPGRADE_SERVICE_PATH}/home`
// 编辑/创建服务
export const UPGRADE_SERVICE_EDIT_PATH = `${UPGRADE_SERVICE_PATH}/edit/`
export const UPGRADE_SERVICE_EDIT_PATH_A = `${UPGRADE_SERVICE_PATH_A}/edit/`
// 审计服务. 审核记录
export const UPGRADE_SERVICE_REVIEW_RECORD_PATH = `${UPGRADE_SERVICE_PATH}/reviewRecord`
export const UPGRADE_SERVICE_REVIEW_RECORD_PATH_A = `${UPGRADE_SERVICE_PATH_A}/reviewRecord`

// 司仪团队管理
export const SIYI_TEAM_MEMBER_PATH = '/localMerchant/siYiTeamGroupMember'
export const SIYI_TEAM_MEMBER_PATH_A = `#${SIYI_TEAM_MEMBER_PATH}`

// 店铺基本信息
export const STORE_INFO_EDIT_PATH = '/localMerchant/editStore'
export const STORE_INFO_EDIT_PATH_A = `#${STORE_INFO_EDIT_PATH}`
